import { render, staticRenderFns } from "./serverErrorView.vue?vue&type=template&id=982f63cc&"
import script from "./serverErrorView.vue?vue&type=script&lang=js&"
export * from "./serverErrorView.vue?vue&type=script&lang=js&"
import style0 from "./serverErrorView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports